// Consolidated people data for Highland Institute
// This file serves as the single source of truth for all personnel

export const peopleData = {
  leadership: [
    {
      id: "michael-heneise",
      name: "Michael T. Heneise",
      honorific: "Dr",
      title: "President",
      category: "Leadership Council",
      affiliation: "Associate Professor of Religious Studies and Social Anthropology, UiT The Arctic University of Norway; Co-Founder",
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/8eyr5vpw_Heneise%20-%20passport%20blue.jpeg",
      email: "michael.t.heneise@uit.no",
      orcid: null,
      website: null
    },
    {
      id: "catriona-child",
      name: "Catriona Child",
      honorific: "Ms",
      title: "Executive Director",
      category: "Leadership Council",
      affiliation: "Executive Director of the Highland Institute",
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/exv37i34_Catriona%20Child.jpg",
      email: null,
      orcid: null,
      website: null
    }
  ],

  honoryVPs: [
    {
      id: "vizovol-mekro",
      name: "Vizovol Mekro",
      honorific: "Dr",
      title: "Honorary Vice President",
      category: "Honorary Vice Presidents",
      affiliation: "Professor Emeritus and Scientist",
      image: null,
      email: null,
      orcid: null,
      website: null
    },
    {
      id: "theyie-keditsu",
      name: "Theyie Keditsu",
      honorific: "Dr",
      title: "Honorary Vice President",
      category: "Honorary Vice Presidents",
      affiliation: "Educator and Author",
      image: null,
      email: null,
      orcid: null,
      website: null
    },
    {
      id: "zavise-rume",
      name: "Zavise Rume",
      honorific: "Dr",
      title: "Honorary Vice President",
      category: "Honorary Vice Presidents",
      affiliation: "Education Policy Advisor",
      image: null,
      email: null,
      orcid: null,
      website: null
    },
    {
      id: "viketoulie-pienyu",
      name: "Viketoulie Pienyü",
      honorific: "Dr",
      title: "Honorary Vice President",
      category: "Honorary Vice Presidents",
      affiliation: "Medical Professional and Community Leader",
      image: null,
      email: null,
      orcid: null,
      website: null
    }
  ],

  staff: [
    {
      id: "ruokuonuo-yhome",
      name: "Ruokuonuo Rose Yhome",
      honorific: "Dr",
      title: "Research Director",
      category: "Senior Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/jixadx5n_Ruokuonuo%20Yhome.jpg",
      email: "rose@highlandinstitute.org",
      orcid: "0000-0002-0426-7541",
      website: null
    },
    {
      id: "rovithono-yhome",
      name: "Rovithono Yhome",
      honorific: "Ms",
      title: "Human Resource Manager",
      category: "Senior Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/4kwmjpua_Rovithono%20Yhome.jpg",
      email: "rovi@highlandinstitute.org",
      orcid: null,
      website: null
    },
    {
      id: "lanuakum-aier",
      name: "Lanuakum Aier",
      honorific: "Mr",
      title: "Deputy Executive Director & Operations Manager",
      category: "Senior Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/bbgi7sgp_Lanuakum%20Aier.jpg",
      email: "lanu@highlandinstitute.org",
      orcid: null,
      website: null
    },
    {
      id: "aditya-kiran-kakati",
      name: "Aditya Kiran Kakati",
      honorific: "Dr",
      title: "Senior Research Associate & Programme Lead (Global Research Outreach and Capacity-Building Initiatives)",
      category: "Senior Staff",
      affiliation: "The Highland Institute; International Institute for Asian Studies (IIAS), Leiden",
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/pnoj5z7w_Aditya%20Kiran%20Kakati.jpg",
      email: "aditya.kakati@iheid.ch",
      orcid: "0000-0003-0477-1593",
      website: "https://highlandinstitute.org/aditya-kiran-kakati/"
    }
  ],

  researchAssistants: [
    {
      id: "saktum-wonti",
      name: "Saktum Wonti",
      honorific: "Ms",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/5845y2ey_Saktum.jpeg",
      email: "saktum@highlandinstitute.org",
      orcid: "0009-0005-4993-6058",
      website: null
    },
    {
      id: "tumuzo-katiry",
      name: "Tümüzo Katiry",
      honorific: "Mr",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/38ck72jl_Tu%CC%88mu%CC%88zo%20Katiry.jpg",
      email: "tumuzo@highlandinstitute.org",
      orcid: "0009-0006-7673-2883",
      website: null
    },
    {
      id: "kevide-lcho",
      name: "Kevide Lcho",
      honorific: "Mr",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/j8ony0is_Kevide%20Lcho.jpg",
      email: "kevide@highlandinstitute.org",
      orcid: null,
      website: null
    },
    {
      id: "sholu-movi",
      name: "Sholu Movi",
      honorific: "Mr",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/qqvd6y3i_Sholu%20Movi.jpg",
      email: "sholu@highlandinstitute.org",
      orcid: "0009-0007-1193-1248",
      website: null
    },
    {
      id: "esther-swu",
      name: "Esther Swu",
      honorific: "Ms",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/2zaty3t7_Esther%20Swu.jpg",
      email: "esther@highlandinstitute.org",
      orcid: null,
      website: null
    },
    {
      id: "aviholi-chishi",
      name: "Aviholi Chishi",
      honorific: "Ms",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/5juooupc_Aviholi.jpeg",
      email: null,
      orcid: null,
      website: null
    },
    {
      id: "akumtong-imchen",
      name: "Akumtong Imchen",
      honorific: "Mr",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/2u1aipg3_Akumtong.jpeg",
      email: "akum@highlandinstitute.org",
      orcid: "0009-0002-6549-5481",
      website: null
    },
    {
      id: "khrieletuonuo-yhome",
      name: "Khrieletuonuo Yhome",
      honorific: "Ms",
      title: "Assistant Researcher",
      category: "Research Staff",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/3t1t9lro_Khrieletuonuo.jpg",
      email: "khriele@highlandinstitute.org",
      orcid: null,
      website: null
    }
  ],

  fellows: [
    {
      id: "jonathon-keats",
      name: "Jonathon Keats",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/q8fso6b6_Jonathon%20Keats.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/jonathon-keats/"
    },
    {
      id: "dharamsing-teron",
      name: "Dharamsing Teron",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/kq9hs3qg_Dharamsing%20Teron.jpg",
      email: "dstlangne.ka@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/dharamsing-teron/",
      bio: "Dharamsing Teron is an independent researcher (graduated in History from Diphu Government College, Gauhati University) from Diphu, Karbi Anglong, who is engaged in documenting Karbi folklore. He is editor of the Karbi Studies series, the first volume of which appeared in 2008 under the banner of Karbi Young Writers' Guild, as a result of combined efforts of activists and new writers. Since then, he has edited Memories, Myths, Metaphors (2nd Edition, April 2012), as well as Reclaiming the Ancestors' Voices (Vol. 2, 2011), co-edited with Sikari Tisso, and Folktales from the Fringe (Vol. 3, collection of popular Karbi folktales/2012), also with Kabeen Teronpi, Kache Teronpi and Valentina Teronpi In Search of the Drongo and Other Stories (Vol. 4) all under the banner of 'Karbi Studies'. He is currently working on 'Karbi Oral History.' He lives in Rongmili, Diphu."
    },
    {
      id: "edward-moon-little",
      name: "Edward Moon-Little",
      honorific: "Dr",
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/ekrq3wrv_Edward%20Moon-Little.jpg",
      email: "emoonlittle@hotmail.co.uk",
      orcid: null,
      website: "https://highlandinstitute.org/edward-moon-little/",
      bio: "Dr. Edward Moon-Little is a Social Anthropologist with diverse interests across academia, museums, and tech. As an academic, Edward has a passion for the history of anthropology and teaching anthropology. At the Highland Institute, he works on the summer school, donates books, and helps curate exhibitions. He also has a strong interest in market research, having conducted projects for leading technology companies including Apple, Meta, and Google. Currently he is affiliated to the South Asia Center at the University of Pennsylvania."
    },
    {
      id: "don-duprez",
      name: "Don Duprez",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/f3ee65us_Don%20Duprez.jpg",
      email: "donduprez@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/don-duprez/",
      bio: "Don Duprez holds a PhD in Social Anthropology at the University of Edinburgh, and holds an MA in Anthropology from California State University, Northridge, and a BA in Anthropology and Archaeology from Georgia State University. His current research explores reproduction, religious hybridisation and efficacy among Hmong diaspora in the United States. Duprez has conducted research among Hmong American communities, Japanese transnationals, Chinese Americans, and Chinese populations, which have included Han communities and the ethnic minority groups of the Dai and Miao peoples. His research interests include health and healing, health and religion, reproduction and reproductive health, feminisms, femininities and masculinities, time and memory, Christianity(ies), shamanic practice and medicine, epistemological and ontological cultural perspectives, transnational and communities in diaspora. Duprez has held teaching positions at California State University, Northridge; Wuhan University of Science and Technology in China; and the University of Edinburgh. He is currently based in Edinburgh, Scotland."
    },
    {
      id: "christian-poske",
      name: "Christian Poske",
      honorific: "Dr",
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/shqxtoin_Christian%20Poske.jpg",
      email: "christian_poske@alumni.soas.ac.uk",
      orcid: null,
      website: "https://highlandinstitute.org/christian-poske/",
      bio: "Dr Christian Poske is an ethnomusicologist whose research interests include the performing arts of east and northeast India and Bangladesh, music and conflict, ecomusicology, oral history, community engagement with archival recordings, applied ethnomusicology and historical ethnomusicology. Christian completed his BA and MA at Rabindra Bharati University in Kolkata and his PhD in Music at SOAS University of London and the British Library with a scholarship from the Arts and Humanities Research Council UK. At the British Library, he worked as an Audio Cataloguer in the UK-wide project Unlocking Our Sound Heritage and as a Bengali Cataloguer at the Department of Asian and African Collections. Subsequently, he conducted three postdoctoral research projects on Bengali and Naga performing arts in India and the UK, supported by the Indian Council for Cultural Relations, the International Association of Sound and Audiovisual Archives and the Firebird Foundation for Anthropological Research (USA). Currently based in India, he assists the Highland Institute in Kohima in establishing an audiovisual archive for ethnographic field recordings."
    },
    {
      id: "aditya-kiran-kakati",
      name: "Aditya Kiran Kakati",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/pnoj5z7w_Aditya%20Kiran%20Kakati.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/aditya-kiran-kakati/"
    },
    {
      id: "margaret-lyngdoh",
      name: "Margaret Lyngdoh",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/ycksi94h_Margaret%20Lyngdoh.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/margaret-lyngdoh/"
    },
    {
      id: "rhelo-kenye",
      name: "Rhelo Kenye",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/fi8jnv9d_Rhelo_Kenye.jpg",
      email: "rhelo.k@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/rhelo-kenye/",
      bio: "Rhelo Kenye is a Guest Faculty at the Centre for Comparative Literature, University of Hyderabad. He has submitted his PhD thesis at the Department of Cultural Studies, English and Foreign Languages University, Hyderabad. His thesis titled \"Folk Blues, Howey, and Pop: The Cultural Practice of Music in Contemporary Naga Society\", examined how music as a creative process of culture had and continues to reinforce, but also reconfigure, meanings and perceptions of the self and society in the Naga milieu. Kenye continues to engage with research in the related fields of social history, the intersection(s) of popular culture and Naga traditional lifeworld, and Naga Writings in English. He is the co-editor of Discoursing the Shifts of Naga Society in Northeast India (upcoming). He is also the coordinator of the Naga Research Scholars' Forum, Hyderabad. He completed his MA in English and MPhil in Comparative Literature from the University of Hyderabad."
    },
    {
      id: "senganglu-thaimei",
      name: "Senganglu Thaimei",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/cshyvmua_Senganglu_Thaimei.png",
      email: "sengmei64@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/senganglu-thaimei/",
      bio: "Senganglu Thaimei is an Associate Professor of English in Delhi University, and currently a Fulbright Post-Doctoral Fellow."
    },
    {
      id: "roderick-wijunamai",
      name: "Roderick Wijunamai",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/7w36v1ef_Roderick_Wijunamai.jpg",
      email: "rdrck.wjnm@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/roderick-wijunamai/",
      bio: "Roderick Wijunamai is a PhD student in the Department of Anthropology, Cornell University. His research is driven by interests in political ecology, agrarian change, climate change, and food systems. Roderick's PhD project in particular seeks to examine the changing livelihood strategies among the upland Konyak Nagas in the Indo-Myanmar borderlands."
    },
    {
      id: "lester-lacombe",
      name: "Lester LaCombe",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/z3cjv2kh_Lester%20Lacombe.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/lester-lacombe/"
    },
    {
      id: "bertrand-lefebvre",
      name: "Bertrand Lefebvre",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/28oiihz6_Bertrand_Lefebvre.jpg",
      email: "bertrand.lefebvre@ifpindia.org",
      orcid: null,
      website: "https://highlandinstitute.org/bertrand-lefebvre/",
      bio: "Bertrand Lefebvre holds a PhD in geography (University of Rouen, 2011). From 2004 to 2009 he was affiliated with CSH-Delhi (UMIFRE 20, MEAE-CNRS) as a doctoral fellow. From 2012 to 2015 he was a post-doctoral fellow with the University of Rouen (IDEES UMR 6266 CNRS) while being posted with the Faculty of Tropical Medicine (Mahidol University, Thailand) to conduct fieldwork on dengue epidemics in Bangkok. Since 2016, he has been an Associate professor of Global Health at EHESP School of Public Health (France) and a research associate with ARENES-EHESP (UMR 6051 CNRS, Rennes) and with CEIAS-EHESS (UMR8564 CNRS, Paris). His teaching covers geomatics, health geography, health impact assessment, health policy analysis, and global health. He has been actively involved in the creation and coordination of the first master of environmental public health in Tunisia (University of Sfax) and the coordination of the Environmental and Occupational Health Sciences track of the Europubhealth+ Master (Erasmus Mundus Joint Master Degree). He has been a visiting professor at the University of Maastricht (the Netherlands, 2019-2021). He has also been involved in several expert committees for France's Ministry of Health and other national and regional agencies on issues such as health data management, healthy urban planning or vector control operations."
    },
    {
      id: "suryasikha-pathak",
      name: "Suryasikha Pathak",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/sv18dwt9_Suryasikha_Pathak.jpg",
      email: "pathak.tsc13@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/suryasikha-pathak/",
      bio: "Suryasikha Pathak is a faculty in the Centre for Tribal Studies, Assam University, Diphu Campus, Karbi Anglong. She had previously worked in the Department of History, Assam University, Silchar Campus. She was a Fulbright Senior Fellow in SUNY Oswego and also a Schlesinger Fellow at Radcliffe College, Harvard University. She is currently working on her book on plains tribes of Assam, focusing on the history of enumerative and ethnographic practices in the colonial period. She likes to work on other interests as well, especially the history of the American Baptist Mission and the remaking of ideas around gender. With this work, she prefers to use personal collections, memoirs, photographs, and letters attempting to make a shift from the official archives. She is a mother of a 6-year-old and divides her time as a mother and as a working academic."
    },
    {
      id: "les-joynes",
      name: "Les Joynes",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/734xv6fp_Leslie%20D.%20Joynes.jpg",
      email: "joynes@bu.edu",
      orcid: null,
      website: "https://highlandinstitute.org/les-joynes/",
      bio: "Les Joynes is a contemporary artist, curator, critic and Fulbright Senior Scholar at the Indira Gandhi National Centre for the Arts in New Delhi examining art and performative cultures in South Asia. He teaches courses in Modern and Contemporary Art History, Experimental Practices and cultural entrepreneurship at Renmin University and Peking University and is Visiting Faculty at both Visva Bharati University in Santiniketan, West Bengal and Royal University of Bhutan examining how ritual and performance index contemporary identity. He has led artist collaboration projects in France, Brazil, South Korea as well as Fulbright-Hays US Public Diplomacy projects in Mongolia and China exploring ritual and performance. He is an editor for ProjectAnywhere, a journal on Site-Specific Art at University of Melbourne Australia. His work has featured on NHK television Japan, Ehime Shimbun, Art Monthly, Sculpture Magazine and he has contributed to Art in America, Flash Art, Springer-Vienna and the Journal for Artistic Research (JAR). Les holds a BA in History and MSc from Boston University, BA (Hons) Fine Art from Central Saint Martins, London; MA Fine Art from Goldsmiths, London; MA from Musashino Art University, Tokyo; PhD from the Faculty of Art, Environment and Technology, Leeds Beckett University, UK; Post-Doctorate from the School of Art and Communications at University of São Paulo, Brazil and research scholar on the Columbia University Visiting Scholar and Scientist Program. He is a Fellow of the Royal Anthropological Institute, the Royal Asiatic Society and the Royal Geographical Society."
    },
    {
      id: "a-sentiyula",
      name: "A. Sentiyula",
      honorific: "Dr",
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/2losmjf1_Dr.%20A.%20Sentiyula.jpg",
      email: "sentiyula9@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/a-sentiyula/",
      bio: "A. Sentiyula has a PhD in English from Nagaland University. She is currently the Head of Department of English at Dimapur Government College, Nagaland. Her area of interest includes Naga Writings in English, Writings from the Northeast of India, and Indigenous Studies. She has co-authored a book titled Studies in Contemporary Naga Writings. Her creative nonfiction writing has been featured in Olio – Obscure Writings From Nagaland, an anthology. Her recent writings include the Foreword to The Diary of Connie Shakespear – The Naga Hills 1900-1902, a publication of Highlander Books under The Highland Institute."
    },
    {
      id: "tiatoshi-jamir",
      name: "Tiatoshi Jamir",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/g8kt8jom_Tiatoshi_Jamir.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/tiatoshi-jamir/"
    },
    {
      id: "kadiguang-panmei",
      name: "Kadiguang Panmei",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/ga5ordna_Kadiguang%20Panmei.jpg",
      email: "kadiguang.panmei@fulbrightmail.org",
      orcid: null,
      website: "https://highlandinstitute.org/kadiguang-panmei/",
      bio: "Kadiguang Panmei is a researcher and musician studying the culture of northeast India and its people through various lenses, including culinary anthropology, migration, geopolitics, and the arts. During the academic year 2022-2023, he pursued his research as a Fulbright Scholar at UCLA's Herb Alpert School of Music, in the Department of Ethnomusicology. He has varied experiences in the academic sector and has conducted several research projects at universities and for NGOs. He has also worked in the music industry as an audio engineer, musician and producer with record studios and labels and currently produces music independently merging indigenous traditional music with modern electronic soundscapes. Kadiguang's passion for music and research motivates him to pursue his vision of preserving and reviving endangered oral traditions of northeast India through applied approaches involving archiving initiatives and community-based grassroots engagement."
    },
    {
      id: "wayne-talbot",
      name: "Wayne Talbot",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/s4ozfa41_Wayne_Talbot.jpg",
      email: "wayne.talbot1@live.com",
      orcid: null,
      website: "https://highlandinstitute.org/wayne-talbot/",
      bio: "Wayne, an environmental science graduate, is experienced in the creation of mass participation projects involving partnerships between academic, commercial and voluntary organisations. He also has a Master of Philosophy, obtained through research into education programme evaluation. Using a bespoke method to improve participation developed over the last 10 years, Wayne has provided logistics and support for community-based programmes at various levels, from the United Nations to small community councils. In particular, he has worked with looked-after children and other groups that do not normally have a voice in community and educational projects. At an international level, Wayne has been a member of the IUCN Communication and Education Committee, and at a local level, he has served on the parish council."
    },
    {
      id: "bisakha-goswami",
      name: "Bisakha Goswami",
      honorific: "Dr",
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/hlt2jwnj_Bisakha.Goswami.jpg",
      email: "bg10.rbu@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/bisakha-goswami/",
      bio: "Dr Bisakha Goswami is an Assistant Professor of Musicology at Rabindra Bharati University, Kolkata, where she has taught since 2012, and Founder Secretary of Muktabodha, a centre for Indological studies and research. Her main research interests are the historical musicology of South Asia as reflected in Sanskrit treatises, Tagore's approach to music education, and the performing arts of ethnic minorities, including those of the Himalayas. She authored the publications Women in the Field of Music: A Study of Bengal (2014) and Tālārṇava: A Musicological Text of Bengal (2017). In addition, she has written several articles on musicology and ethnomusicology in India, Tagore's views on introducing musicology in Indian universities, and unknown Sanskrit treatises on Indian musicology. Dr Goswami studied Social Cultural Anthropology at the University of Calcutta, where she completed her MSc in 2001, after which she studied Musicology at Rabindra Bharati University between 2001-2003. In 2015, Dr Goswami received her doctorate from Rabindra Bharati University for editing the 15th-century Sanskrit manuscript Ānandasañjīvana, which includes sections on Indian musicology. She currently investigates South Asian musicology of the medieval and early modern age."
    },
    {
      id: "akumjung-pongen",
      name: "Akumjung Pongen",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/rf70thdt_Akumjung%20Pongen.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/akumjung-pongen/"
    },
    {
      id: "ketoukhrieu",
      name: "Ketoukhrieü",
      honorific: "Dr",
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/ndw74d57_ketoukhrieu.jpg",
      email: "k2khrie@gmail.com",
      orcid: null,
      website: "https://highlandinstitute.org/ketoukhrieu/",
      bio: "Ketoukhrieü (Ph.D.) is currently working as an Assistant Professor, Department of Political Science, Kohima College, Kohima under Nagaland University, Nagaland. She has obtained Ph.D in Political Science on the topic, \"Society and Politics in the Borderlands: A Case Study of a Konyak Naga Village Located at the Indo-Myanmar Borderland\" from Gauhati University Assam in 2015. Her academic and research interests include borderland and border communities in South Asia, identity politics in Northeast India, peace and conflict resolution, and human rights, particularly of marginal groups such as women, indigenous communities, minorities, and persons with disabilities. She was awarded University Grants Commission–Junior Research Fellowship (2010-2012) and Zubaan-Sasakawa Peace Foundation Grant for Young Researchers from Northeast India-III (2020-2021). Her current research project is an ICSSR-funded Major Research Project titled \"Living at the Periphery: Territory, Culture, and Identity of the Tikhir Nagas, a Scheduled Tribe in Nagaland near the Indo-Myanmar Border\" (2023-2025)."
    },
    {
      id: "alison-venetia-graham-betts",
      name: "Alison Venetia Graham Betts",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/w179yzw2_Alison%20Betts.jpg",
      email: "alison.betts@sydney.edu.au",
      orcid: null,
      website: "https://highlandinstitute.org/alison-venetia-graham-betts/",
      bio: "Alison has an outstanding international reputation for innovative archaeological research leadership in difficult areas. She has had a four-decade working life dedicated to opening new research pathways in the prehistory of the Middle East and Central Asia. Over the past two decades, she has been particularly concerned with the influence of Eurasian innovations on the rise of early Chinese social complexity. Through work in the cross-roads region of Xinjiang, she and her colleagues have been able to make major contributions to the fundamental questions of the spread of early domesticates into China from the west, and the concomitant spread of eastern domesticates to the west. Seeking proof of these transitions led her to open up a new project in Indian Kashmir on the southern Himalayan rim. Her cutting-edge work in this sphere of inquiry is on the front line of a surge in paleobotanical research across Inner Asia."
    },
    {
      id: "anna-notsu",
      name: "Anna Notsu",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/g4ayizgt_Anna%20Notsu.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/anna-notsu/"
    },
    {
      id: "jelle-j-p-wouters",
      name: "Jelle J P Wouters",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/2skjiezj_Jelle%20J.P.%20Wouters.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/jelle-j-p-wouters/"
    },
    {
      id: "ruokuonuo-rose-yhome",
      name: "Ruokuonuo Rose Yhome",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/jixadx5n_Ruokuonuo%20Yhome.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/ruokuonuo-rose-yhome/"
    },
    {
      id: "meera-baindur",
      name: "Meera Baindur",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: null,
      image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/mgpup4g8_Meera_Baindur.jpg",
      email: null,
      orcid: null,
      website: "https://highlandinstitute.org/meera-baindur/",
      bio: "Meera Baindur is an environmental philosopher, educator, and researcher at the Manipal Academy of Higher Education, Bengaluru Campus. Her work spans different aspects of Environmental Humanities, including nature and environment in Indian philosophical and cultural traditions, cultural geography, and eco-pedagogies."
    },
    {
      id: "jyoti-patil",
      name: "Jyoti Patil",
      honorific: null,
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: "Executive Director (Chief Secretary), Aaorhi, Uttarakhand",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_7a4f11f8-6c06-4e1c-b433-73d9453c195e/artifacts/qv1kfttw_Jyoti.webp",
      email: "jyosheen1@gmail.com",
      orcid: null,
      website: null
    },
    {
      id: "ek-raj-ojha",
      name: "Ek Raj Ojha",
      honorific: "Dr",
      title: "Highland Fellow",
      category: "Fellows & Visiting Scholars",
      affiliation: "Rural and Regional Development Planner, Nepal",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_7a4f11f8-6c06-4e1c-b433-73d9453c195e/artifacts/12bov734_Picture1.jpg",
      email: "drekrajojha@gmail.com",
      orcid: null,
      website: null
    }
  ],
  
  visitingResearchers: [
    {
      id: "aniruddha-guha",
      name: "Aniruddha Guha",
      honorific: null,
      title: "Collaborative Doctoral Researcher",
      category: "Visiting & Collaborative Researchers",
      affiliation: "King's College London; The Highland Institute",
      image: "https://customer-assets-0z36b82j.emergentagent.net/job_7a4f11f8-6c06-4e1c-b433-73d9453c195e/artifacts/d974d56c8ded902e_Aniruddha_Guha_Portrait_HI.webp",
      email: "aniruddha.guha@kcl.ac.uk",
      orcid: null,
      website: null,
      bio: "Aniruddha Guha is an MPhil/PhD student at King's College London, holding the KDSAH Arts & Humanities PhD Studentship (Collaborative Doctoral Award) in partnership with The Highland Institute. He earned his MA in History from Presidency University, Kolkata. His research delves into the history of opium in colonial Nagaland, with a specific focus on the Veda peak region and the broader eastern Himalayan borderlands. His intellectual curiosity lies at the confluence of colonial history, borderland societies, and the political and economic forces that shaped this region."
    }
  ]
};

// Helper function to get all people as a flat array
export const getAllPeople = () => {
  return [
    ...peopleData.leadership,
    ...peopleData.honoryVPs,
    ...peopleData.staff,
    ...peopleData.researchAssistants,
    ...peopleData.fellows,
    ...peopleData.visitingResearchers
  ];
};

// Helper function to get person by ID
export const getPersonById = (id) => {
  const allPeople = getAllPeople();
  return allPeople.find(person => person.id === id);
};

// Helper function to get people by category
export const getPeopleByCategory = (category) => {
  const allPeople = getAllPeople();
  return allPeople.filter(person => person.category === category);
};

// Get all unique categories
export const getAllCategories = () => {
  return [
    "Leadership Council",
    "Honorary Vice Presidents",
    "Senior Staff",
    "Research Staff",
    "Fellows & Visiting Scholars",
    "Visiting & Collaborative Researchers"
  ];
};
